<template>
  <master-layout :enable-scroll-event="true">
    <div
      class="flex flex-col w-full px-5 pt-4 pb-2 bg-[#F6F5F1]"
      :class="{ '!pt-[92px]': isIos() }"
    >
      <BackButton compact fallback-route="/home" />
      <section>
        <h1
          class="text-[2rem] leading-[2.5rem] sm:text-[3rem] sm:leading-[4rem] font-bold pt-[24px] mb-[4px] text-[#0B0C0F]"
        >
          E-invites
        </h1>
      </section>
      <Loading v-if="loading" />
      <div v-else-if="eInvites.length > 0" class="sm:mt-[16px] mt-[24px]">
        <EInvite
          v-for="invite in eInvites"
          :id="invite.slug"
          :ref="invite.slug"
          :key="invite.eventName"
          class="mb-[32px]"
          :name="invite.eventName"
          :description="invite.eventDescription"
          :assets="invite.assets"
        />
      </div>
      <p v-else class="text-[#acacac] text-center mt-[24px]">No e-invites to show.</p>
    </div>
  </master-layout>
</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/common/LoadingState.vue';
import BackButton from '@/components/common/BackButton.vue';
import EInvite from '@/components/EInvitesPage/EInvite.vue';
import { isIosNativeOnly } from '@/utils/platform-check';

export default {
  components: {
    Loading,
    BackButton,
    EInvite,
  },
  computed: {
    ...mapState('cms', {
      isCmsLoading: state => state.loading,
      eInvites: state => state.eInvites,
    }),
  },
  async ionViewWillEnter() {
    console.log(this.$route);
    await Promise.all([
      this.$store.dispatch('cms/fetchCmsContent', {
        entityName: 'resources/e-invites',
        stateName: 'eInvites',
      }),
      this.$store.dispatch('updates/getUpdates', 'all'),
    ]);
  },
  methods: {
    isIos() {
      return isIosNativeOnly();
    },
  },
};
</script>
